'use es6';

import * as DataType from '../../../constants/dataTypes';
export const CRM_SEARCH_DATA_TYPES = [DataType.CONTACTS, DataType.COMPANIES, DataType.DEALS, DataType.TICKETS, DataType.LINE_ITEMS, DataType.PRODUCTS, DataType.QUOTAS, DataType.ENGAGEMENT, DataType.CALLS, DataType.CONVERSATIONS, DataType.ENGAGEMENT_EMAILS, DataType.MEETINGS, DataType.NOTES, DataType.TASKS, DataType.FEEDBACK];